<script setup lang="ts">
import { Button } from "@frontiers-vue3/public-pages";
import type { IJournal } from "~/types";
import DialogSubmitManuscript from "~/components/common/components/DialogSubmitManuscript/DialogSubmitManuscript.vue";
import { RTImpactLinkTitleEnum } from "~/enums";

const terminology = useTerminologyStore();

const participatingJournalsToSubmit = ref<IJournal[]>(
  useMain().getParticipatingJournalsToSubmit
);

const isDialogOpen = ref(false);
</script>
<template>
  <div id="SubmitSection" class="RtSidePanel__Section">
    <p>
      Manuscripts can be submitted to this
      {{ terminology.getTerm("researchTopic") }} via the main journal or any
      other participating journal.
    </p>
    <Button
      :text="RTImpactLinkTitleEnum.SUBMIT_MANUSCRIPT"
      size="Medium"
      @click="isDialogOpen = !isDialogOpen" />
  </div>

  <DialogSubmitManuscript
    :participating-journals-to-submit="participatingJournalsToSubmit"
    :is-dialog-open="isDialogOpen" />
</template>
<style lang="scss" scoped>
.RtSidePanel__Section {
  padding-top: 8px;

  p {
    @include f-16-300;
    color: $grey70;
  }

  button {
    width: 100%;
    margin: 0;

    &:hover {
      border-color: transparent;
    }
  }
}
</style>
